import { render, staticRenderFns } from "./sektorlerDetail.vue?vue&type=template&id=6129c398&scoped=true&"
import script from "./sektorlerDetail.vue?vue&type=script&lang=js&"
export * from "./sektorlerDetail.vue?vue&type=script&lang=js&"
import style0 from "./sektorlerDetail.vue?vue&type=style&index=0&id=6129c398&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6129c398",
  null
  
)

export default component.exports